import { useForm, Controller } from 'react-hook-form'
import { mockAccounts, mockContacts } from '../../lib/api/mockData'
import { FormInput, FormSelect, FormDialog } from '../../components/ui'

interface TaskFormProps {
  open: boolean
  onClose: () => void
  onSubmit: (data: any) => void
  initialData?: any
}

export const TaskForm = ({ open, onClose, onSubmit, initialData }: TaskFormProps) => {
  const { control, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm({
    defaultValues: initialData || {
      title:       '',
      status:      'Not Started',
      priority:    'Medium',
      dueDate:     '',
      contactName: '',
      relatedToId: '',
      description: '',
    },
  })

  const handleClose = () => {
    reset()
    onClose()
  }

  const handleFormSubmit = (data: any) => {
    onSubmit(data)
    handleClose()
  }

  return (
    <FormDialog
      open={open}
      onClose={handleClose}
      onSave={handleSubmit(handleFormSubmit)}
      title={initialData ? 'Edit Task' : 'New Task'}
      saving={isSubmitting}
      maxWidth="sm"
    >
      <Controller
        name="title"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Subject"
            required
            placeholder="e.g. Follow up with client"
            error={!!errors.title}
            helperText={errors.title?.message as string}
          />
        )}
      />

      <Controller
        name="description"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Description"
            multiline
            rows={3}
            placeholder="Any additional notes…"
            error={!!errors.description}
            helperText={errors.description?.message as string}
          />
        )}
      />

      <Controller
        name="dueDate"
        control={control}
        render={({ field }) => (
          <FormInput
            {...field}
            label="Due Date"
            type="date"
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: (() => {
              const now = new Date()
              const tzOffset = now.getTimezoneOffset() * 60000
              return new Date(now.getTime() - tzOffset).toISOString().split('T')[0]
            })() }}
            error={!!errors.dueDate}
            helperText={errors.dueDate?.message as string}
          />
        )}
      />

      <Controller
        name="relatedToId"
        control={control}
        render={({ field }) => (
          <FormSelect
            label="Related To (Account)"
            options={mockAccounts.map((a) => a.name)}
            value={field.value ?? null}
            onChange={(v) => field.onChange(v ?? '')}
            error={!!errors.relatedToId}
            helperText={errors.relatedToId?.message as string}
          />
        )}
      />

      <Controller
        name="contactName"
        control={control}
        render={({ field }) => (
          <FormSelect
            label="Contact Name"
            options={mockContacts.map((c) => `${c.firstName} ${c.lastName}`)}
            value={field.value ?? null}
            onChange={(v) => field.onChange(v ?? '')}
            error={!!errors.contactName}
            helperText={errors.contactName?.message as string}
          />
        )}
      />
    </FormDialog>
  )
}
